import { Box } from "@mui/material"
import React, { useCallback, useContext } from "react"
import { ComparaisonModeContext } from "../../../contexts/ComparaisonModeContext"
import { ComparaisonMode } from "../../../contexts/ComparaisonMode"
import { ToggleButton } from "../../../../../../../../../components/buttons/ToggleButton/ToggleButton"

export function ComparaisonModeSelector(): React.JSX.Element {
  const { comparaisonMode, setComparaisonMode } = useContext(ComparaisonModeContext)

  const handleClick: (newComparaisonMode: ComparaisonMode) => void = useCallback(
    (newComparaisonMode) => {
      setComparaisonMode(newComparaisonMode)
    },
    [setComparaisonMode]
  )

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: 2 }}>
      <ToggleButton
        onClick={() => handleClick(ComparaisonMode.LOT)}
        label="Comparaison par lot"
        isSelected={comparaisonMode === ComparaisonMode.LOT}
      />
      <ToggleButton
        onClick={() => handleClick(ComparaisonMode.ITEM)}
        label="Comparaison par item"
        isSelected={comparaisonMode === ComparaisonMode.ITEM}
      />
      <ToggleButton
        onClick={() => handleClick(ComparaisonMode.MATERIAL)}
        label="Comparaison par FDES"
        isSelected={comparaisonMode === ComparaisonMode.MATERIAL}
      />
    </Box>
  )
}
